import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {environment} from 'src/environments/environment';
import {ActivatedRoute} from '@angular/router';
import {HttpParams} from '@angular/common/http';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-new-user',
    standalone: true,
    imports: [],
    template: ``,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUserComponent {
    private readonly route = inject(ActivatedRoute);

    constructor() {
        this.route.queryParams.pipe(take(1)).subscribe(params => {
            const httpParams = new HttpParams({fromObject: params});
            window.location.href = `${environment.reactOnlineUrl}/new-user/resident?${httpParams.toString()}`;
        });
    }
}
